import {IMPORT_IN_PROGRESS, IMPORT_IN_PROGRESS_FINISHED} from '../actions/types';

const INITIAL_STATE = false;

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case IMPORT_IN_PROGRESS:
            return true;
        case IMPORT_IN_PROGRESS_FINISHED:
            return false;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/ImportInProgressReducer.js